import { Avatar, Card, Grid, Stack, Typography, useTheme } from "@mui/material";
import Title1Component from '../../components/title/title1Component';
import { useTranslation } from "react-i18next";
import data from '../../data/data.json';

const OurTeam = () => {
    const {t} = useTranslation();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                className="bodySpacing bodyPadding"
                pb={{xs: 2, md: 5}}
            >
                <Title1Component 
                    title={t('about.team.title')} 
                    description={t('about.team.description')}
                />

                <Grid
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    container
                    width='100%'
                    spacing={{xs: 1, md: 2}}
                >
                    {
                        data.about.team.map((item, index) => {
                            return <Grid
                                key={index}
                                size={{xs: 6, md: 3}}
                            >
                                <TeamMember data={item} index={index}/>
                            </Grid>
                        })
                    }
                </Grid>
            </Stack>
        </>
    );
}

export default OurTeam;

const TeamMember = ({data, index}) => {
    const {t} = useTranslation();
    const theme = useTheme();

    return (
        <>
            <Card
                elevation={3}
                sx={{
                    p: {xs: 2, md: 4},
                    minHeight: 150
                }}
                data-aos="zoom-in"
                data-aos-delay={index * 150}
                data-aos-duration="1000"
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                >
                    <Avatar 
                        alt="Profile"
                        src={data.profile}
                        sx={{ 
                            width: {xs: 75, md: 150},
                            height: {xs: 75, md: 150}
                        }}
                    />

                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 12, md: 14, lg: 16}}
                        textAlign='center'
                        color={theme.palette.text.primary}
                        lineHeight={1.25}
                        pt={2}
                    >
                        {t(`${data.name}`)}
                    </Typography>

                    <Typography
                        fontWeight={500}
                        fontSize={12}
                        textAlign="center"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                    >
                        {t(`${data.role}`)}
                    </Typography>
                </Stack>
            </Card>
        </>
    );
}